import { Truck } from "lucide-react";

export const TrackingTimeline = ({ order }) => {
  const events = order?.tracking || [];
  const hasInfo = order?.tracking_number || order?.carrier || events.length > 1;
  if (!hasInfo) {
    return <p className="text-xs text-muted-foreground" data-testid={`no-tracking-${order?.order_id}`}>No tracking added yet — waiting for the seller to ship.</p>;
  }
  return (
    <div data-testid={`tracking-${order.order_id}`} className="space-y-2">
      {(order.carrier || order.tracking_number) && (
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <Truck className="w-3.5 h-3.5 text-primary" />
          {order.carrier && <span className="font-medium">{order.carrier}</span>}
          {order.tracking_number && <span className="font-mono text-muted-foreground">#{order.tracking_number}</span>}
        </div>
      )}
      <ol className="relative border-l border-border/60 ml-1.5 space-y-3 pl-4">
        {events.map((e, i) => {
          const latest = i === events.length - 1;
          return (
            <li key={`${e.status}-${i}`} className="relative">
              <span className={`absolute -left-[21px] top-0.5 w-3 h-3 rounded-full border-2 border-background ${latest ? "bg-primary" : "bg-muted-foreground/40"}`} />
              <p className={`text-xs ${latest ? "font-semibold" : "font-medium text-muted-foreground"}`}>{e.status}</p>
              <p className="text-[11px] text-muted-foreground">{new Date(e.at).toLocaleString()}</p>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
